module.exports = __webpack_public_path__ + "img/law3m-m@2.920a2d8e.jpg";